// What the "Przerwa" overlay does with one input event. While it is shown every press, release,
// click, key and wheel is swallowed (Phaser listens on the whole window, so a click on the card
// would otherwise also land in the game), and a press wakes the player. The overlay hides at once,
// but the waking press is followed to its release however long it is held (a child's long press,
// a slow tap), and for TRAIL_MS after that (its click, a phone's compatibility mouse events), so
// the waking tap or key never harvests, walks or presses a button. PRESS_CAP_MS is only a safety
// net for a release that never arrives (the pointer left the window).
export const SHIELD_EVENTS = [
  'pointerdown', 'pointerup', 'pointercancel', 'mousedown', 'mouseup', 'click', 'dblclick',
  'contextmenu', 'touchstart', 'touchend', 'touchcancel', 'keydown', 'keyup', 'keypress', 'wheel',
];
const WAKING = new Set(['pointerdown', 'mousedown', 'touchstart', 'keydown']);
const RELEASE = new Set(['pointerup', 'pointercancel', 'mouseup', 'touchend', 'touchcancel', 'keyup']);
export const TRAIL_MS = 600;
export const PRESS_CAP_MS = 10_000;

// shown: the card is up. pressUntil: the waking press is still held (until its release, at most
// this time). trailUntil: the press was released; its follow-up events are swallowed until then.
export const SHIELD_REST = Object.freeze({ shown: false, pressUntil: 0, trailUntil: 0 });

export function shieldStep(state, type, now) {
  if (!SHIELD_EVENTS.includes(type)) return { state, swallow: false, wake: false };
  if (state.shown) {
    const wake = WAKING.has(type);
    const next = wake && now >= state.pressUntil ? { ...state, pressUntil: now + PRESS_CAP_MS } : state;
    return { state: next, swallow: true, wake };
  }
  if (now < state.pressUntil) {
    const next = RELEASE.has(type) ? { ...state, pressUntil: 0, trailUntil: now + TRAIL_MS } : state;
    return { state: next, swallow: true, wake: false };
  }
  return { state, swallow: now < state.trailUntil, wake: false };
}

// Nothing left to swallow: the overlay may take its window listeners off.
export function shieldIdle(state, now) {
  return !state.shown && now >= state.pressUntil && now >= state.trailUntil;
}
